import StoreType, { type StoreBase } from "store2";

export class LocalStorageService {
  private readonly store: StoreBase;

  constructor(namespace: string) {
    this.store = StoreType.namespace(namespace);
  }

  public get<TModel>(key: string) {
    return this.store.get(key) as TModel;
  }

  public set<TModel>(key: string, value: TModel) {
    this.store.set(key, value);

    return this.get<TModel>(key);
  }

  public delete(key: string) {
    this.store.remove(key);
  }

  public clear() {
    this.store.clear();
  }
}
